import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Timeline from '@mui/lab/Timeline';
import AddIcon from '@mui/icons-material/Add';
import NoteIcon from '@mui/icons-material/NoteAlt';
import {
  useSelector,
  useDispatch,
} from 'react-redux';

import { Divider } from '@mui/material';
import notesIcon from '../../../../../images/unused-undraw-illustrations/notes.svg';
import NoteItem from '../../../../../components/NoteItem';
import NoteTypeSelect from '../../../../../components/EnumSelects/NoteTypeSelect';
import {
  getHorseNotes,
  getHorseNoteHighlights,
} from '../../../../../redux/horse/actions';

const NotesCardComponent = ({
  id,
  isAdmin,
  openAddEditNoteModal,
}) => {
  const dispatch = useDispatch();

  // Redux state
  const horse = useSelector((state) => state.horse.horse);
  const horseNotes = useSelector((state) => state.horse.horseNotes);
  const isFetchingHorseNotes = useSelector((state) => state.horse.isFetchingHorseNotes);

  // State
  const [pageSize] = React.useState(25);
  const [page, setPage] = React.useState(1);
  const [sortModel] = React.useState([
    {
      field: 'createdTimestamp',
      sort: 'desc',
    },
  ]);
  const [noteTypeFilter, setNoteTypeFilter] = React.useState(['Note', 'Medical', 'Competition', 'TackEquipment', 'Billing', 'Farrier']);

  React.useEffect(() => {
    dispatch(getHorseNotes(id, (page - 1), pageSize, sortModel.map((s) => `&sort=${s.field},${s.sort}`), null, noteTypeFilter || null));
    dispatch(getHorseNoteHighlights(id));
  }, [id, page, noteTypeFilter]);

  const closeAddEditModalCallbcak = () => {
    // reload
    dispatch(getHorseNotes(id, (page - 1), pageSize, sortModel.map((s) => `&sort=${s.field},${s.sort}`), null, noteTypeFilter || null));
  };

  return (
    <Card>
      <CardHeader
        avatar={<Avatar><NoteIcon /></Avatar>}
        title={(
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            <NoteTypeSelect value={noteTypeFilter} onChange={(e) => { setNoteTypeFilter(e.target.value); }} includeAllOption multiple size="small" />
            <Button
              sx={{
                width: 120,
                minWidth: '120px',
              }}
              size="small"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => openAddEditNoteModal(null, null, closeAddEditModalCallbcak)}
            >
              Add Note
            </Button>
          </Box>
        )}
      />
      <Divider />
      <CardContent>
        <Timeline>
          {
            horseNotes.content.map((note) => (
              <NoteItem
                note={note}
                horseId={id}
                pinnedHorseNoteId={horse.activeNote
                  ? horse.activeNote.id
                  : null}
                key={note.id}
                includeUserInfo
                isLoading={isFetchingHorseNotes}
                onEdit={() => openAddEditNoteModal(note, noteTypeFilter, closeAddEditModalCallbcak)}
                isAdmin={isAdmin}
              />
            ))
          }
          {
            (!isFetchingHorseNotes && horseNotes.content.length === 0) && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" align="center" component="div" sx={{ m: 4 }}>
                  No Notes
                </Typography>
                <img
                  src={notesIcon}
                  alt="girl with notes"
                  style={{
                    width: 250,
                    display: 'block',
                    margin: 'auto',
                    marginBottom: '1rem',
                  }}
                />
              </Box>
            )
          }

        </Timeline>

        <Pagination count={horseNotes.totalPages} variant="outlined" page={page} onChange={(event, value) => { setPage(value); }} disabled={isFetchingHorseNotes} />
      </CardContent>
    </Card>
  );
};

NotesCardComponent.propTypes = {
  id: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  openAddEditNoteModal: PropTypes.func.isRequired,
};
NotesCardComponent.defaultProps = {};

export default NotesCardComponent;
